/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { LedgerItemType } from './LedgerItemType.js';
import {
    LedgerItemTypeFromJSON,
    LedgerItemTypeFromJSONTyped,
    LedgerItemTypeToJSON,
} from './LedgerItemType.js';
import type { LedgerStatementMatch } from './LedgerStatementMatch.js';
import {
    LedgerStatementMatchFromJSON,
    LedgerStatementMatchFromJSONTyped,
    LedgerStatementMatchToJSON,
} from './LedgerStatementMatch.js';

/**
 * 
 * @export
 * @interface LedgerItem
 */
export interface LedgerItem {
    /**
     * 
     * @type {string}
     * @memberof LedgerItem
     */
    uuid?: string;
    /**
     * 
     * @type {LedgerItemType}
     * @memberof LedgerItem
     */
    type?: LedgerItemType;
    /**
     * 
     * @type {string}
     * @memberof LedgerItem
     */
    reason?: string;
    /**
     * 
     * @type {LedgerStatementMatch}
     * @memberof LedgerItem
     */
    statementMatch?: LedgerStatementMatch;
    /**
     * 
     * @type {Array<LedgerStatementMatch>}
     * @memberof LedgerItem
     */
    statementMatches?: Array<LedgerStatementMatch>;
}

/**
 * Check if a given object implements the LedgerItem interface.
 */
export function instanceOfLedgerItem(value: object): boolean {
    return true;
}

export function LedgerItemFromJSON(json: any): LedgerItem {
    return LedgerItemFromJSONTyped(json, false);
}

export function LedgerItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): LedgerItem {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'type': json['type'] == null ? undefined : LedgerItemTypeFromJSON(json['type']),
        'reason': json['reason'] == null ? undefined : json['reason'],
        'statementMatch': json['statementMatch'] == null ? undefined : LedgerStatementMatchFromJSON(json['statementMatch']),
        'statementMatches': json['statementMatches'] == null ? undefined : ((json['statementMatches'] as Array<any>).map(LedgerStatementMatchFromJSON)),
    };
}

export function LedgerItemToJSON(value?: LedgerItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'uuid': value['uuid'],
        'type': LedgerItemTypeToJSON(value['type']),
        'reason': value['reason'],
        'statementMatch': LedgerStatementMatchToJSON(value['statementMatch']),
        'statementMatches': value['statementMatches'] == null ? undefined : ((value['statementMatches'] as Array<any>).map(LedgerStatementMatchToJSON)),
    };
}

